import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Thakoon = ({featuredProjectsList}) => {
  const project = getProject('thakoon');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          className="g-row"
          component={{
            posterVideo: '216454262'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            To bridge the gap between what consumers want and what fashion
            retailers traditionally provide, fashion darling Thakoon approached
            us to help define the strategy and design for its new eCommerce
            site.
          </p>
        </AnimateIn>

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170503202121/thakoon-1.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="process">Process</h2>
          <p>
            With four seasons a year, and six product drops per season in mind,
            we conducted workshops with the Thakoon team to understand and
            define the new approach. During 14 week sprints, we built and
            iterated over countless prototypes and conducted regular user
            testing to arrive at the ideal shopping experience.
          </p>
        </AnimateIn>

        <Quote
          className="g-row quote--marks"
          component={{
            quote:
              'The method of profiling and walking in the steps of our customers in such detail was great, we need to do it more often.',
            quotee: 'Thakoon team'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503202123/thakoon-2.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503202124/thakoon-3.jpg'
          }}
        />

        <Image
          className="g-row component--no-margin"
          component={{
            image: '//images.yourmajesty.co/20170503202126/thakoon-5.jpg'
          }}
        />

        <Image
          className="g-row"
          component={{
            image: '//images.yourmajesty.co/20170508182610/thakoon.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            The website launched just in time for New York Fashion Week, with{' '}
            <em>New York Magazine</em> calling it “fast and informative ...
            Thakoon has perfected instant runway shopping.”
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="partners">Partners</h2>
          <p>
            Suburbia
            <br />
            LYONSCG
          </p>
        </AnimateIn>

        <LinkList
          component={{
            title: 'Press',
            useLinksDirectly: true,
            links: [
              {
                title: 'Thakoon Perfects Instant Runway Shopping',
                url:
                  'http://nymag.com/thecut/2016/09/thakoon-perfects-instant-runway-shopping.html',
                source: 'New York Magazine'
              },
              {
                title: 'The Second Coming of Thakoon',
                url:
                  'https://www.businessoffashion.com/articles/bof-exclusive/bof-exclusive-the-second-coming-of-thakoon',
                source: 'BoF'
              }
            ]
          }}
        />

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Collaborative Working Sessions',
                  'Experience Mapping',
                  'Interviews & User Testing',
                  'Prototyping & Validation',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: ['Art Direction', 'UI/UX Design', 'Visual Design']
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Thakoon;
